import styled from 'styled-components'
import { Chip as CapabilityChip } from 'containers/SubSidebar/shared/GroupedModelDropdown/styled'

/* Extends the shared capability chip so the row hover/selected white-fill
   rule applies to it too; only geometry differs. */
export const Chip = styled(CapabilityChip)`
  gap: 4px;
`

export const ThunderImage = styled.img`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
`

export const Wrapper = styled.div`
  display: flex;
`
